import * as React from "react";

// Types
import Icon from "../../types/Icon.interface";

const IconDownload: React.FC<Icon> = (props: Icon) => {
  const { color = "#002D5A", className, style, onClick } = props;

  return (
    <svg
      width={41}
      height={40}
      viewBox="0 0 41 40"
      className={className}
      style={style}
      onClick={onClick}
    >
      <g stroke={color} strokeWidth={2} fill="none" fillRule="evenodd">
        <path d="M20.254 11v12.857" />
        <path strokeLinejoin="bevel" d="M14.254 28.571h11.143" />
        <path d="M26.254 17.857l-6 6-6-6" />
      </g>
    </svg>
  );
};

export default IconDownload;
